import { AddClickTraceHandler } from "./click-trace";

// auto detect data-persistent="true" on dialog (no ESC / backdrop click close)
// auto detect data-dismiss="modal" on buttons inside
export function ShowDialogModal(el:HTMLDialogElement|string,persistent:boolean) {
  if(typeof el==="string") el=document.querySelector(el) as HTMLDialogElement;
  if(persistent===undefined) persistent=el.dataset.persistent !==undefined && el.dataset.persistent.toLowerCase()==="true";
  const fEsc=(e:Event)=> e.preventDefault();
  const fClick=(e:Event)=> {
    let cEl=<HTMLElement>e.target;
    if(cEl===el && !persistent) el.close(); //backdrop click
    if(cEl.closest("dialog")!=el) return; // click inside nested dialog - ignore it
    while(cEl !== el) {
      if(cEl.dataset.dismiss==='modal') {
        e.preventDefault();
        (<HTMLDialogElement>el).close()
        return;
      }
      cEl=cEl.parentElement;
    }
  }
  const fClose=()=>{
    if(persistent) (<HTMLDialogElement>el).removeEventListener("cancel",fEsc);
    (<HTMLDialogElement>el).removeEventListener("click",fClick);
    (<HTMLDialogElement>el).removeEventListener("close",fClose);
  }
  if(persistent) el.addEventListener("cancel",fEsc);
  el.addEventListener("click",fClick);
  el.addEventListener("close",fClose);
  el.showModal();
  return ()=>(<HTMLDialogElement>el).close();
}

AddClickTraceHandler((el:HTMLElement,evt:Event)=> el.dataset.toggle==="modal",
    (el:HTMLElement)=> ShowDialogModal(el.dataset.target || el.getAttribute("href"),false));
